import React from "react";
import { grey } from "@mui/material/colors";
import { AddCircleOutline, Delete } from "@mui/icons-material";
import { formatStringToNumber } from "utils/formatters";
import { useFieldArray, useFormContext } from "react-hook-form";
import { InputField, CurrencyInputField, SelectField } from "components/form";
import { Stack, Button, Box, Typography, IconButton } from "@mui/material";
import { EquipmentFormValue } from "../../../types";
import { equipmentAttachment, equipmentAttachmentTypes } from "../../../constants";
import { FieldsContainer } from "../../components/FieldsContainer";

export const Attachments = () => {
  const { control } = useFormContext<EquipmentFormValue>();
  const { fields, append, remove } = useFieldArray({ control, name: "attachments" });

  return (
    <Stack gap="1rem">
      <Typography variant="h6" component="span">
        Attachments
      </Typography>

      {fields.map(({ id }, index) => (
        <Stack gap="1rem">
          <Stack
            sx={{
              gap: "0.3rem",
              padding: "0.3rem",
              alignItems: "center",
              flexDirection: "row",
              background: grey["200"],
            }}>
            <IconButton
              size="small"
              onClick={() => {
                remove(index);
              }}>
              <Delete fontSize="small" color="error" />
            </IconButton>

            <Typography>#{index + 1} Attachment</Typography>
          </Stack>

          <FieldsContainer key={id} columns={6}>
            <InputField
              control={control}
              label="Qty. Per Asset"
              inputProps={{ type: "number" }}
              formatter={formatStringToNumber}
              name={`attachments.${index}.quantityPerAsset`}
            />

            <InputField label="Manufacturer" name={`attachments.${index}.manufacturer`} control={control} />

            <SelectField
              label="Type"
              control={control}
              name={`attachments.${index}.type`}
              options={equipmentAttachmentTypes}
            />

            <InputField label="Model" name={`attachments.${index}.model`} control={control} />

            <InputField
              label="Category"
              control={control}
              inputProps={{ disabled: true }}
              name={`attachments.${index}.category`}
            />

            <CurrencyInputField
              control={control}
              label="Wholesale Cost"
              textFieldProps={{ disabled: true }}
              name={`attachments.${index}.unitCost`}
            />
          </FieldsContainer>
        </Stack>
      ))}

      <Box>
        <Button
          size="small"
          startIcon={<AddCircleOutline />}
          onClick={() => {
            append({ ...equipmentAttachment });
          }}>
          Add
        </Button>
      </Box>
    </Stack>
  );
};
